import BSJVideoLossModal from './BSJ_video_loss-modal.vue'
export default BSJVideoLossModal
